import { render, staticRenderFns } from "./FeesNoticeDetailsTable.vue?vue&type=template&id=6d1643b4"
import script from "./FeesNoticeDetailsTable.vue?vue&type=script&lang=js"
export * from "./FeesNoticeDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports